// actions.js
import {
  FETCH_KYB_DETAIL_REQUEST,
  FETCH_KYB_DETAIL_SUCCESS,
  FETCH_KYB_DETAIL_FAILURE,
} from "../types";

export const fetchKybDetailRequest = (kycId, type) => ({
  type: FETCH_KYB_DETAIL_REQUEST,
  payload: kycId, // Include kycId in the payload
  type: type,
});

export const fetchKybDetailSuccess = (data) => ({
  type: FETCH_KYB_DETAIL_SUCCESS,
  payload: data,
});

export const fetchKybDetailFailure = (error) => ({
  type: FETCH_KYB_DETAIL_FAILURE,
  payload: error,
});
